export enum InvoiceDetailsFiltersEnum {
  Q = 'q',
  PAYMENT_STATUS = 'paymentStatus',
  PICKUP_DATE = 'pickupDate',
}
